import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ContentViewProgressMutationVariables = Types.Exact<{
  input: Array<Types.SyncProgressInput> | Types.SyncProgressInput;
}>;


export type ContentViewProgressMutation = { syncProgress: { success?: boolean | null } };


export const ContentViewProgressDocument = /*#__PURE__*/ gql`
    mutation contentViewProgress($input: [SyncProgressInput!]!) {
  syncProgress(input: $input) {
    success
  }
}
    `;

export function useContentViewProgressMutation() {
  return Urql.useMutation<ContentViewProgressMutation, ContentViewProgressMutationVariables>(ContentViewProgressDocument);
};